import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { SOLUTIONS } from "@/data/content";

export default function Solutions() {
  return (
    <div data-testid="solutions-index" className="pt-32 pb-24">
      <Seo title="Platforms" description="Four institutional platforms built and owned by AlchamisGroup — Alchamis PLM, Alchamis CRM, Alouvya, Date'n'Dog." path="/platforms" />
      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <span className="overline">Platforms</span>
            <h1 className="font-display text-5xl sm:text-7xl text-[#001B54] mt-6 leading-[1.02]">
              Four institutional platforms.
              <span className="block italic gold-text">One operating standard.</span>
            </h1>
          </div>
          <div className="col-span-12 lg:col-span-5 text-[#3F4A6B] leading-relaxed">
            <p>
              Every AlchamisGroup platform is built with the discipline of a regulated industry and the
              elegance of a luxury product. Designed, engineered, and operated in-house.
            </p>
          </div>
        </div>
      </section>

      <section className="mt-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 space-y-10">
          {SOLUTIONS.map((s, idx) => (
            <Link
              to={`/platforms/${s.slug}`}
              key={s.slug}
              data-testid={`solutions-row-${s.slug}`}
              className="group grid grid-cols-12 gap-6 border-t border-[#001B54]/10 pt-10 hover:border-gold/40 transition-colors"
            >
              <div className="col-span-12 lg:col-span-3 flex items-start justify-between">
                <span className="number-badge">{s.ventureCode}</span>
                <ArrowUpRight size={20} className="text-gold opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500 lg:hidden" />
              </div>
              <div className="col-span-12 lg:col-span-6">
                <h2 className="font-display text-4xl sm:text-5xl text-[#001B54] leading-tight">{s.name}</h2>
                <p className="text-gold/90 text-xs tracking-[0.18em] uppercase mt-2">{s.tagline}</p>
                <p className="text-[#3F4A6B] mt-6 max-w-2xl leading-relaxed">{s.mission}</p>
              </div>
              <div className="hidden lg:flex col-span-3 items-start justify-end">
                <ArrowUpRight size={28} className="text-gold opacity-50 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
